// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

type Props = {
  active?: boolean,
  container: any,
  delay?: number,
  opacity?: number,
  text?: string,
};

export default class BlockingStatus extends React.PureComponent<Props> {
  static defaultProps = {
    delay: 200,
    opacity: 0.7,
  };

  render() {
    if (!this.props.container) return null;

    const Comp = (
      <div
        css={{
          textAlign: 'center',
          background: 'rgba(20, 156, 130, 0.6)',
          color: 'white',
          padding: '5px',
          margin: '70px 0 5px',
        }}
      >
        {this.props.text}
      </div>
    );

    return ReactDOM.createPortal(
      <div
        css={[
          {
            pointerEvents: 'none',
            opacity: 0,
            width: '100%',
            height: '100%',
            background: `rgba(255, 255, 255, ${this.props.opacity})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1000,
            // $FlowFixMe
            transition: `opacity ${this.props.delay}ms ease-in-out`,
          },
          this.props.active && {
            pointerEvents: 'auto',
            opacity: 1,
          },
          this.props.excludeHeader && {
            top: '60px',
            height: 'calc(100% - 60px)',
          },
        ]}
      >
        {Comp}
      </div>,
      this.props.container,
    );
  }
}
